import { ContactConfiguration, Persona } from "@/types/campaign";
import { useState } from "react";

export function usePersonas(savedConfig: ContactConfiguration | null) {
  const [personas, setPersonas] = useState<Persona[]>(
    savedConfig?.personas ?? [],
  );

  const addPersona = (persona: Persona) => {
    setPersonas((prev) => [...prev, persona]);
  };

  const removePersona = (index: number) => {
    setPersonas((prev) => prev.filter((_, i) => i !== index));
  };

  const updatePersona = (index: number, persona: Persona) => {
    setPersonas((prev) => {
      const next = [...prev];
      next[index] = persona;
      return next;
    });
  };
  const reorderPersona = (items: Persona[]) => {
    setPersonas(() => {
      return items;
    });
  };

  const clearPersonas = () => {
    setPersonas([]);
  };

  return {
    personas,
    addPersona,
    removePersona,
    updatePersona,
    clearPersonas,
    reorderPersona,
  };
}
